import { z } from 'zod';

const schema = z.object({
  VITE_API_BASE_URL: z.url(),
  VITE_PUBLIC_SITE_URL: z.url(),
  /** CT One ID base URL — id.ct839.dev (dev) / id.ct839.com (prod). */
  VITE_ONEID_BASE_URL: z.url(),
});

const parsed = schema.safeParse(import.meta.env);
if (!parsed.success) {
  console.error('Invalid frontend env:', z.flattenError(parsed.error).fieldErrors);
  throw new Error('Invalid frontend env. See apps/web/.env.example.');
}

export const env = parsed.data;
